/**
 * Validates that a money value does not contain a decimal point.
 * Handles both string and number inputs (for programmatic usage).
 * Should be called with the original (non-transformed) input value.
 */
export const isWholeNumber = (value?: string | number | null): boolean => {
  if (value === undefined || value === null || value === '') {
    return true;
  }
  if (typeof value === 'number') {
    return Number.isInteger(value);
  }
  const cleaned = String(value).replaceAll(',', '').trim();
  return !cleaned.includes('.');
};

export const isValidMoney = (value?: string): boolean => {
  if (!value) {
    return true;
  }
  const parsed = Number.parseFloat(value);
  return !Number.isNaN(parsed) && parsed >= 0;
};

export const createMaxMoneyValidator =
  (max: number) =>
  (value?: string): boolean => {
    if (!value) {
      return true;
    }
    const parsed = Number.parseFloat(value);
    return parsed <= max;
  };

export const isNonZeroMoney = (value?: string): boolean => {
  if (!value) {
    return true;
  }
  const parsed = Number.parseFloat(value);
  return parsed !== 0;
};
